<template>
  <div>
    <div class="f-inline-group">
      <legend
        :class="{ 'f-field__label--required' : isRequired }"
        class="f-field__label"
      >
        {{ $t(`fields.record.${fieldName}.label`) }}
      </legend>
      <div
        v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
        class="f-field__tooltip"
      >
        <Tooltip>
          <p>
            {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
          </p>
        </Tooltip>
      </div>
    </div>
    <div class="f-field">
      <div class="f-inline-group">
        <div class="f-field-advanced-search__controller-select">
          <select
            v-model="modelValue.option"
            class="f-field__input f-field__input--select"
            @change="$emit('change', modelValue)"
          >
            <option
              v-for="opt in ['all', 'any', 'none']"
              :key="fieldName + opt"
              :value="opt"
            >
              {{ $t(`advancedsearch.fields.string.options.${opt}`) }}
            </option>
          </select>
        </div>
        <TextAreaField
          v-model="modelValue.value"
          :field-name="`record.${fieldName}`"
          :placeholder="placeholder"
          :is-required="isRequired"
          :show-label="false"
          :error="error"
          @input="validate"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TextAreaField from '#src/components/utils/fields/TextAreaField.vue'
import { MetadataUtils } from '@scholar/metadata-utils/main'
import Tooltip from '#src/components/utils/Tooltip.vue'

export default {
  components: {
    TextAreaField,
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    hideTooltip: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change', 'input', 'update:modelValue'],
  data() {
    return {
      validation: { status: true },
      parser: new MetadataUtils().getParserByType(this.recordType)
    }
  },
  computed: {
    error() {
      return this.validation.status ? {} : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.field?.error}`) }
    },
    placeholder() {
      if (this.$te(`advancedsearch.fields.${this.fieldName}.placeholder`)) {
        return this.$t(`advancedsearch.fields.${this.fieldName}.placeholder`)
      } else {
        return this.$t(`fields.record.${this.fieldName}.placeholder`)
      }
    }
  },
  created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = ''
    }
    if (this.modelValue.option === null) {
      this.modelValue.option = 'all'
    }
  },
  methods: {
    async validate(val) {
      this.validation = await this.parser.validateByField(this.validatorName || this.fieldName, val)
      if (!this.isRequired && this.modelValue.value === '') {
        this.validation = { status: true }
      }
      this.modelValue.isValid = this.validation.status
      this.$emit('input', this.modelValue)
      this.$emit('update:modelValue', this.modelValue)
    }
  }
}
</script>
